// ============================================================================
// JAPANESE BIBLE PASSAGES - Shinkaiyaku
// ============================================================================
// ストロング番号付きの日本語聖書本文

export const biblePassagesJp = {
  "Souseiki_1": {
    book: "創世記",
    chapter: 1,
    title: "世界の創造",
    verses: [
      { number: 1, text: "初めに、神が天と地を創造した。", strong: ["H7225", "H430", "H1254"] },
      { number: 2, text: "地は茫漠として何もなかった。やみが大水の上にあり、神の霊が水の上を動いていた。", strong: ["H776", "H8414", "H7307"] },
      { number: 3, text: "神は仰せられた。「光があれ。」すると光があった。", strong: ["H430", "H559", "H216"] },
      { number: 4, text: "神は光を見て良しとされた。神は光とやみとを区別された。", strong: ["H430", "H7200", "H216", "H2896"] },
      { number: 5, text: "神は光を昼と名づけ、やみを夜と名づけられた。夕があり、朝があった。第一日。", strong: ["H430", "H7121", "H3117", "H3915"] },
      { number: 6, text: "神は仰せられた。「大空が水の真ん中にあれ。水と水との間に区別があれ。」", strong: ["H430", "H7549", "H4325"] },
      { number: 7, text: "神は大空を造り、大空の下にある水と、大空の上にある水とを区別された。そのようになった。", strong: ["H430", "H6213", "H7549"] },
      { number: 8, text: "神は大空を天と名づけられた。夕があり、朝があった。第二日。", strong: ["H430", "H7121", "H8064"] },
      { number: 27, text: "神は人をご自身のかたちとして創造された。神のかたちとして彼を創造し、男と女とに彼らを創造された。", strong: ["H430", "H1254", "H120", "H6754"] },
      { number: 31, text: "神はお造りになったすべてのものを見られた。見よ。それは非常に良かった。夕があり、朝があった。第六日。", strong: ["H430", "H7200", "H2896", "H3966"] }
    ]
  },
  "Shihen_23": {
    book: "詩篇",
    chapter: 23,
    title: "主は私の羊飼い",
    verses: [
      { number: 1, text: "主は私の羊飼い。私は、乏しいことがありません。", strong: ["H3068", "H7462", "H2637"] },
      { number: 2, text: "主は私を緑の牧場に伏させ、いこいの水のほとりに伴われます。", strong: ["H7257", "H4999", "H5148", "H4325"] },
      { number: 3, text: "主は私のたましいを生き返らせ、御名のために、私を義の道に導かれます。", strong: ["H7725", "H5315", "H5148", "H6664"] },
      { number: 4, text: "たとい、死の陰の谷を歩くことがあっても、私はわざわいを恐れません。あなたが私とともにおられますから。あなたのむちとあなたの杖、それが私の慰めです。", strong: ["H1980", "H1516", "H6757", "H3372", "H7626"] },
      { number: 5, text: "私の敵の前で、あなたは私のために食事をととのえ、私の頭に油をそそいでくださいます。私の杯は、あふれています。", strong: ["H6186", "H7979", "H6887", "H1878", "H3563"] },
      { number: 6, text: "まことに、私のいのちの日の限り、いつくしみと恵みとが、私を追って来るでしょう。私は、いつまでも、主の家に住まいましょう。", strong: ["H2896", "H2617", "H7291", "H3117", "H1004", "H3068"] }
    ]
  },
  "Yohane_3": {
    book: "ヨハネの福音書",
    chapter: 3,
    title: "イエスとニコデモ",
    verses: [
      { number: 16, text: "神は、実に、そのひとり子をお与えになったほどに、世を愛された。それは御子を信じる者が、ひとりとして滅びることなく、永遠のいのちを持つためである。", strong: ["G2316", "G25", "G2889", "G1325", "G5207"] },
      { number: 17, text: "神が御子を世に遣わされたのは、世をさばくためではなく、御子によって世が救われるためである。", strong: ["G2316", "G649", "G2889", "G2919", "G4982"] },
      { number: 18, text: "御子を信じる者はさばかれない。信じない者は神のひとり子の御名を信じなかったので、すでにさばかれている。", strong: ["G4100", "G2919", "G3686", "G5207", "G2316"] }
    ]
  },
  "Piripijin_4": {
    book: "ピリピ人への手紙",
    chapter: 4,
    title: "神の平安",
    verses: [
      { number: 4, text: "いつも主にあって喜びなさい。もう一度言います。喜びなさい。", strong: ["G5463", "G2962", "G3825"] },
      { number: 6, text: "何も思い煩わないで、あらゆるばあいに、感謝をもってささげる祈りと願いによって、あなたがたの願い事を神に知っていただきなさい。", strong: ["G3309", "G4335", "G1162", "G2169"] },
      { number: 7, text: "そうすれば、人のすべての考えにまさる神の平安が、あなたがたの心と思いをキリスト・イエスにあって守ってくれます。", strong: ["G1515", "G2316", "G5242", "G3563", "G5432"] },
      { number: 13, text: "私は、私を強くしてくださる方によって、どんなことでもできるのです。", strong: ["G1411", "G1743", "G5547"] }
    ]
  }
};

export default biblePassagesJp;
